export default __webpack_public_path__ + "static/media/TopicTips_GIFs.78acb77b.svg";